export const USERS_SERVICE_URI = 'https://users-service.nlt.carplanner.com'
export const OFFERS_EXPLORER_SERVICE_URI = 'https://offers-explorer.nlt.carplanner.com'
export const DEAL_SERVICE_URI = 'https://deals-service.nlt.carplanner.com'
export const FILE_MANAGER_URI = 'https://file-manager.nlt.carplanner.com'
